import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "../axiosBaseQuery";

export const PRODUCTS_API_REDUCER_KEY = "productsApi";

export const productsApi = createApi({
  reducerPath: PRODUCTS_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["product"],
  endpoints: (builder) => ({
    getProductsList: builder.query({
      query: ({ page, limit }) => ({
        url: `admin/companies/products/?page=${page}&limit=${limit}`,
      }),
      providesTags: ["product"],
    }),

    getProduct: builder.query({
      query: (id) => ({
        url: `admin/companies/products/${id}/`,
      }),
      providesTags: ["product"],
    }),

    createProduct: builder.mutation({
      query: (body) => ({
        url: `admin/companies/products/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["product"],
    }),
    uploadProducts: builder.mutation({
      query: (body) => ({
        url: `/companies/products/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["product"],
    }),
    updateProduct: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `/admin/companies/products/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["product"],
    }),

    deleteProduct: builder.mutation({
      query: (id) => ({
        url: `/admin/companies/products/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["product"],
    }),
  }),
});

export const {
  useGetProductsListQuery,
  useGetProductQuery,
  useUploadProductsMutation,
  useCreateProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
} = productsApi;
